import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomVerticalTwoAndThreeSelectionComponent } from './custom-vertical-two-and-three-selection.component';
import {CmsConfig, ConfigModule, I18nModule, UrlModule} from '@spartacus/core';
import {CustomItemVerticalTwoAndThreeSelectionModule} from '../custom-item-vertical-two-and-three-selection/custom-item-vertical-two-and-three-selection.module';
import {CustomCarouselModule} from '../../../../spartacus/custom/shared/components/custom-carousel/custom-carousel.module';
import {MediaModule} from '@spartacus/storefront';
import {RouterModule} from "@angular/router";

@NgModule({
  declarations: [CustomVerticalTwoAndThreeSelectionComponent],
  exports: [CustomVerticalTwoAndThreeSelectionComponent],
  imports: [
    CommonModule,
    I18nModule,
    RouterModule, UrlModule,
    CustomCarouselModule,
    MediaModule,
    CustomItemVerticalTwoAndThreeSelectionModule,
    ConfigModule.withConfig({
      cmsComponents: {
        VerticalTwoAndThreeSelectionComponent: {
          component: CustomVerticalTwoAndThreeSelectionComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomVerticalTwoAndThreeSelectionModule { }
